import { TableHTMLAttributes } from 'react';
import { clsx } from 'clsx';

type TableProps = Omit<
  TableHTMLAttributes<HTMLTableElement>,
  'className' | 'border'
> & {
  border?: boolean;
  fixed?: boolean;
};

export const Table = ({
  children,
  border = true,
  fixed = false,
  ...rest
}: TableProps) => {
  return (
    <div className="w-full overflow-x-auto">
      <table
        {...rest}
        className={clsx('w-full', border && 'border', fixed && 'table-fixed')}
      >
        {children}
      </table>
    </div>
  );
};
